module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm_m"
  }, [_vm._v("O body swayed to music, O brightening glance, How can we know the dancer from the dance?")]), _vm._v(" "), _c('p', {
    staticClass: "fm_m2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("W. B. YEATS,")]), _vm._v(" ‘Among School Children’")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2877983d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Fm2.vue
// module id = 69
// module chunks = 0